import React, { useState, useEffect, useRef} from "react";
import axios from "axios";
import { BASE_URL } from "apiConfig";

export default function useOBV(tickerList) {

const [OBV, setOBV] = useState([]);
const [OBVLoading, setMarketInfoLoading] = useState(false);

useEffect(() => {
    getPriceInfo();
}, [tickerList]);

async function getPriceInfo() {
    setMarketInfoLoading(true);
    try {
    const response = await axios(`${BASE_URL}/OBV/`, {
        params: {
        ticker: JSON.stringify(tickerList),
        // window:window,
        // overBought:overBought,
        // overSold:overSold,
        // dateFrequency:dateFrequency,
        },
    });
   
    const data = response.data
    setOBV(JSON.parse(data))
   
    } catch (error) {
    console.error(error);
    } 
    setMarketInfoLoading(false);
    
}
return {OBV,OBVLoading};
}